module.exports = __webpack_public_path__ + "static/media/stadium_story01.e7d976de.mp4";